import { useMemo } from "react";

import { DEFAULT_SPACE_NAME } from "views/constants";

import { ModuleCreationWizardStep } from "./types";
import useModuleAvailableSpaces from "../Module/useModuleAvailableSpaces";
import { INITIAL_FORM_DATA } from "./constants";

const useInitialValues = () => {
  const availableSpaces = useModuleAvailableSpaces();

  const initialValues = useMemo(() => {
    return {
      ...INITIAL_FORM_DATA,
      [ModuleCreationWizardStep.Vcs]: {
        ...INITIAL_FORM_DATA[ModuleCreationWizardStep.Vcs],
        space:
          availableSpaces.find((s) => s.id === DEFAULT_SPACE_NAME)?.id || availableSpaces[0]?.id,
      },
    };
  }, [availableSpaces]);

  return initialValues;
};

export default useInitialValues;
